//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { AutoCompleteExtraProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { CommissionSalaryFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import { useCompanyService, useSalaryDeviationsService } from "serviceHooks";
//#endregion
import { QueryStateHelper } from "utils/helpers";

function useCommissionSalaryReportFilterDefinition() {
  const salaryDeviationsService = useSalaryDeviationsService();
  const companyService = useCompanyService();
  const filterFormFields: GenericFormSection<CommissionSalaryFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        yearAndMonth: {
          label: TranslationKeys.Common.TimePeriod,
          type: FormEnums.FormFieldType.MONTH,
        },
        personName: {
          label: TranslationKeys.Common.Employee,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          extraProps: {
            referenceFieldName: FormFieldConstants.SalaryDeviation.Filter.PersonId,
            items: (searchStr: string) => companyService.SearchPersonsAutoComplete(searchStr, false),
          } as AutoCompleteExtraProps<CommissionSalaryFormTypes.Filter>,
          hidden: !salaryDeviationsService.hasAdminPermissions(),
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<CommissionSalaryFormTypes.Filter> = {
    yearAndMonth: QueryStateHelper.monthQueryEncoder(FormFieldConstants.CommissionSalary.Filter.YearAndMonth),
    personId: QueryStateHelper.numberQueryEncoder(FormFieldConstants.CommissionSalary.Filter.PersonId),
    personName: QueryStateHelper.stringQueryEncoder(FormFieldConstants.CommissionSalary.Filter.PersonName),
  };

  return { filterFormFields, filterQueryStateHandler };
}

export default useCommissionSalaryReportFilterDefinition;
